function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.81 7.22h-1.49c-1.09 0-1.94.85-1.94 1.94v1.49c0 1.09.85 1.94 1.94 1.94h1.91c-.08 1.81-.5 2.08-1.71 2.79-.36.21-.47.67-.26 1.03.14.24.39.37.65.37.13 0 .26-.03.38-.1 1.79-1.06 2.46-1.75 2.46-4.83V9.18c0-1.09-.87-1.96-1.94-1.96zm-6.13 0H8.19c-1.09 0-1.94.85-1.94 1.94v1.49c0 1.09.85 1.94 1.94 1.94h1.91c-.08 1.81-.5 2.08-1.71 2.79-.36.21-.47.67-.26 1.03.14.24.39.37.65.37.13 0 .26-.03.38-.1 1.79-1.06 2.46-1.75 2.46-4.83V9.18c-.01-1.09-.88-1.96-1.94-1.96z"
})));